<template>
  <div class="recordReview">
    <el-container>
      <el-aside class="el-aside-l-wrap por">
        <a
          @click="showL = !showL"
          class="poa btn-l btn-switch"
          :class="{ cur: showL }"
        ></a>
        <transition name="el-zoom-in-left">
          <!-- v-if="!isShowAddReviewOpinions" -->
          <div class="el-aside-l por transition-box" v-show="showL">
            <div class="recordReview-l por recordReview-l-generateReport">
              <a @click="resetChecked" class="reset" title="查看全篇">
                <i class="iconfont icon-other_zhongzhi"></i>
              </a>
              <div class="recordReview-l-catalog shadowlaw hlh60">
                <i class="iconfont icon-huodongmulupeizhi"></i>
                目录
              </div>
              <div class="recordReview-l-treeCon shadowlaw">
                <el-collapse v-model="activeNames">
                  <el-collapse-item :title="title" name="1">
                    <happy-scroll size="3" color="#c1c4c6" :hide-horizontal="true" resize>
                      <!-- :default-expanded-keys="[1]"
											:default-checked-keys="[5]" -->
                      <div>
                        <el-tree
                          :data="treeData"
                          node-key="id"
                          :current-node-key="currentKey"
                          :props="defaultProps"
                          @check-change="handleNodeClick"
                          ref="tree"
                          check-on-click-node
                          check-strictly
                          :default-expanded-keys="defaultkey"
                        ></el-tree>
                      </div>
                    </happy-scroll>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
            <div class="recordReview-l-list shadowlaw">
              <div class="recordReview-l-catalog shadowlaw shadowR hlh60">
                <i class="iconfont icon-ai-list"></i>
                审查意见列表
              </div>
              <div class="recordReview-l-table tableBox tableBoxRecordReview por">
                <el-table
                  :data="reviewOpinionData"
                  stripe
                  height="210"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="item_id__content"
                    label="对应条款"
                    min-width="32%"
                    align="left"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      <span @click="editOpinionFun(scope.row.id)">
                        {{ scope.row.item_id__content }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="advise_type"
                    label="类型"
                    min-width="16%"
                    align="left"
                    :show-overflow-tooltip="true"
                  >
                  </el-table-column>
                  <el-table-column
                    label="提交时间"
                    min-width="30%"
                    align="center"
                    :show-overflow-tooltip="true"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.create_time }}
                      <!-- {{handleTime(scope.row.create_time)}} -->
                    </template>
                  </el-table-column>
                </el-table>
                <a
                  class="more fr"
                  @click="toReviewOpinionFun"
                  v-if="reviewOpinionData && reviewOpinionData.length > 5"
                >
                  more&gt;&gt;
                  <!-- <i class="iconfont icon-changjiantou"></i> -->
                </a>
              </div>
            </div>
          </div>
        </transition>
        <transition name="el-zoom-in-left">
          <div
            class="el-aside-l por transition-box el-aside-l-addReviewOpinions"
            v-show="showL"
            v-if="isShowAddReviewOpinions"
          >
            <viewReviewOpinions
              @parentAddReviewOpinionsFun="parentAddReviewOpinionsFun"
              :data="termsData"
              :currentKey="currentKey"
              :curMode="curMode"
              ref="viewReviewOpinions"
            ></viewReviewOpinions>
          </div>
        </transition>
      </el-aside>
      <el-main class="recordReview-c-wrap">
        <div class="shadowlaw recordReview-c por">
          <div
            class="recordReview-c-operation recordReview-c-operationGenerateReport poa"
          >
            <div class="operation">
              <a
                class="new f_transition report"
                :href="downloadUrl + report_file"
                v-if="report_file"
              >
                导出报告
              </a>
              <!-- <a class="new f_transition add" @click="backReviewFun">
									退回继续审查
								</a>
								<a class="new f_transition upload" @click="newRoundReviewFun">
									开始新一轮审查
								</a> -->
              <a
                class="new f_transition upload"
                @click="completeReviewFun"
                v-if="reviewStageStatus == '进行中' && report_file"
              >
                完成结束审查
              </a>
            </div>
          </div>
          <div class="fileBoxCon fileBoxConRecordReviewCenter">
            <div class="fileBoxConRecordReviewCenterCon">
              <happy-scroll size="3" color="#c1c4c6" :hide-horizontal="true" resize>
                <div class="con">
                  <!-- <h2 class="title" v-if="currentKey==uuid">{{title}}</h2>
									<div v-if="centerTextType=='chapter'">
										<div v-for="(item,index) in chooseData" :key="index">
											<h3 class="chapter" @click="centerCurIdFun(item)">{{item.label}}</h3>
											<p class="paragraph" @click="centerCurIdFun(inside)" v-for="(inside,index) in item.children" :key="index">{{inside.label}}</p>
										</div>
									</div>
									<div v-if="centerTextType=='items'">
										<div>
											<p class="paragraph" @click="centerCurIdFun(inside)" v-for="(inside,index) in chooseData" :key="index">{{inside.label}}</p>
										</div>
									</div> -->
                  <h2 class="title">{{ title }}</h2>
                  <div>
                    <div v-for="(item, index) in chooseData" :key="index">
                      <div v-if="item.label">
                        <div v-if="item.tag == 'total'">
                          <!-- 不存在_就是整篇的 整篇tag=total -->
                          <p class="paragraph">综合意见</p>
                          <div
                            class="advice"
                            v-for="(inside, index) in item.advise"
                            :key="index"
                          >
                            <p class="paragraph">
                              （审核人{{ inside.author_name }} {{ inside.create_time }}）
                            </p>
                            <p class="paragraph">
                              建议<i>{{ inside.advise_type }}</i
                              >内容： <span>{{ inside.content }}</span>
                            </p>
                            <p class="paragraph">
                              依据和理由： <span>{{ inside.reason }}</span>
                            </p>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="item.label">
                            <p class="paragraph" @click="centerCurIdFun(item)">
                              {{ item.label }}
                            </p>
                            <div
                              class="advice"
                              v-for="(insideItem, index) in item.advise"
                              :key="index"
                            >
                              <p class="paragraph">
                                （审核人{{ insideItem.author_name }}
                                {{ insideItem.create_time }}）
                              </p>
                              <p class="paragraph">
                                建议<i>{{ insideItem.advise_type }}</i
                                >内容： <span>{{ insideItem.content }}</span>
                              </p>
                              <p class="paragraph">
                                依据和理由： <span>{{ insideItem.reason }}</span>
                              </p>
                            </div>
                          </div>
                          <div v-if="item.children && item.children.length > 0">
                            <div
                              class="paragraph"
                              @click="centerCurIdFun(inside)"
                              v-for="(inside, index) in item.children"
                              :key="index"
                            >
                              <p class="paragraph">{{ inside.label }}</p>
                              <div
                                class="advice"
                                v-for="(item2, index) in inside.advise"
                                :key="index"
                              >
                                <p class="paragraph">
                                  （审核人{{ item2.author_name }}
                                  {{ item2.create_time }}）
                                </p>
                                <p class="paragraph">
                                  建议<i>{{ item2.advise_type }}</i
                                  >内容： <span>{{ item2.content }}</span>
                                </p>
                                <p class="paragraph">
                                  依据和理由： <span>{{ item2.reason }}</span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- item.label为空则为具体的某一条 -->
                      <div v-else>
                        <div
                          class="paragraph"
                          @click="centerCurIdFun(inside)"
                          v-for="(inside, index) in item.children"
                          :key="index"
                        >
                          <p class="paragraph">{{ inside.label }}</p>
                          <div
                            class="advice"
                            v-for="(item2, index) in inside.advise"
                            :key="index"
                          >
                            <p class="paragraph">
                              （审核人{{ item2.author_name }} {{ item2.create_time }}）
                            </p>
                            <p class="paragraph">
                              建议<i>{{ item2.advise_type }}</i
                              >内容： <span>{{ item2.content }}</span>
                            </p>
                            <p class="paragraph">
                              依据和理由： <span>{{ item2.reason }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </happy-scroll>
            </div>
          </div>
        </div>
      </el-main>
      <el-aside class="el-aside-r-wrap por">
        <a
          @click="showR = !showR"
          class="poa btn-l btn-switch"
          :class="{ cur: showR }"
        ></a>
        <transition name="el-zoom-in-left">
          <div width="200px" class="el-aside-r por transition-box" v-show="showR">
            <div class="recordReview-l">
              <div
                class="shadowlaw shadowl hlh60 recordReview-r-catalog-firstTitle recordReview-l-catalog tac"
              >
                审查原文
              </div>
              <div
                class="recordReview-r-con shadowlaw shadowl recordReview-r-conGenerateReport"
              >
                <div
                  class="fileBoxCon fileBoxConRecordReviewCenter fileBoxConGenerateReport"
                >
                  <happy-scroll
                    size="3"
                    color="#c1c4c6"
                    :hide-horizontal="true"
                    :scroll-top.sync="rightScrollTop"
                    v-if="rightData.length > 0"
                  >
                    <div class="con" ref="rightData">
                      <h2 class="title" v-if="currentKey == uuid">{{ titleSource }}</h2>
                      <div v-if="centerTextType == 'chapter'">
                        <div v-for="(item, index) in rightData" :key="index">
                          <h3
                            class="chapter"
                            :class="{ cur: currentKey == item.id }"
                            :ref="`title${item.id}`"
                            :id="item.id"
                          >
                            {{ item.label }}
                          </h3>
                          <p
                            class="paragraph"
                            v-for="(inside, index) in item.children"
                            :key="index"
                            :class="{
                              cur: currentKey == inside.id || currentKey == item.id,
                            }"
                            :ref="`title${inside.id}`"
                            :id="inside.id"
                          >
                            {{ inside.label }}
                          </p>
                        </div>
                      </div>
                      <div v-if="centerTextType == 'items'">
                        <div>
                          <p
                            class="paragraph"
                            v-for="(inside, index) in rightData"
                            :key="index"
                            :class="{ cur: currentKey == inside.id }"
                            :ref="`title${inside.id}`"
                            :id="inside.id"
                          >
                            {{ inside.label }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </happy-scroll>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </el-aside>
    </el-container>
    <!-- 退回继续审查 -->
    <returnReviewOpinion ref="returnReviewOpinion"></returnReviewOpinion>
    <!-- 开始新一轮的审查 -->
    <uploadAgain ref="uploadAgain" data="newRoundReview"></uploadAgain>
  </div>
</template>
<script>
//查看审查意见
import viewReviewOpinions from "./viewReviewOpinions.vue";
//退回继续审查
import returnReviewOpinion from "./returnReviewOpinion.vue";
//开始新一轮的审查-重新上传
import uploadAgain from "../recordReview/uploadAgain.vue";

export default {
  components: {
    viewReviewOpinions,
    returnReviewOpinion,
    uploadAgain,
  },
  data() {
    return {
      rightScrollTop: 200,
      uuid: "", //需要解析的文件uuid
      process: Number, //审查进度

      //右侧start=====
      showR: true, //展开收起
      loadingcnkiData: false, //加载中
      rightData: [], //右侧数据
      controlReturnTop: false, // 控制返回顶部布尔值
      titleSource: "", //标题
      //右侧end=====

      //左侧start=====
      showL: true, //展开收起
      activeNames: "1",
      reviewOpinionData: [
        //左侧审查意见列表数据
        {
          terms: "第三十九条",
          type: "修改",
          date: "2021-03-29",
        },
        {
          terms: "第三十九条2",
          type: "修改",
          date: "2021-03-28",
        },
        {
          terms: "第三十九条",
          type: "修改",
          date: "2021-03-29",
        },
        {
          terms: "第三十九条",
          type: "修改",
          date: "2021-03-29",
        },
        {
          terms: "第三十九条2",
          type: "修改",
          date: "2021-03-28",
        },
      ],
      subTitle: "（2006年11月30日云南省第十届人民代表大会常务委员会第二十六次会议通过）", //副标题
      treeData: [
        //左侧导航树
        // {
        // 	id: 1,
        // 	label: "第一章　总则",
        // 	children: [
        // 		{
        // 			id: 11,
        // 			label: "11第一条　为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。"
        // 		},
        // 		{
        // 			id: 12,
        // 			label: "12第二条　艾滋病防治工作坚持预防为主、防治结合的方针，建立政府领导、部门负责、社会参与的机制，采取宣传教育、行为干预和关怀救助等措施，实行综合防治。"
        // 		},
        // 		{
        // 			id: 13,
        // 			label: "13第三条  艾滋病防治工作坚持预防为主、防治结合的方针，实施政府组织领导、部门各负其责、全社会共同参与的工作机制，坚持综合治理、突出重点"
        // 		},
        // 		{
        // 			id: 14,
        // 			label: "14第四条  县级以上人民政府应当加强对艾滋病防治工作的领导，制定实施方案，明确部门职责，健全工作协调、考核、监督机制，推行领导负责制、工作责任制，将艾滋病防治工作纳入综合考核范围。"
        // 		}
        // 	]
        // },
        // {
        // 	id: 2,
        // 	label: "第二章　法规",
        // 	children: [
        // 		{
        // 			id: 21,
        // 			label: "21第一条　为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。"
        // 		},
        // 		{
        // 			id: 22,
        // 			label: "22第二条　艾滋病防治工作坚持预防为主、防治结合的方针，建立政府领导、部门负责、社会参与的机制，采取宣传教育、行为干预和关怀救助等措施，实行综合防治。"
        // 		},
        // 		{
        // 			id: 23,
        // 			label: "23第三条  艾滋病防治工作坚持预防为主、防治结合的方针，实施政府组织领导、部门各负其责、全社会共同参与的工作机制，坚持综合治理、突出重点"
        // 		},
        // 		{
        // 			id: 24,
        // 			label: "24第四条  县级以上人民政府应当加强对艾滋病防治工作的领导，制定实施方案，明确部门职责，健全工作协调、考核、监督机制，推行领导负责制、工作责任制，将艾滋病防治工作纳入综合考核范围。"
        // 		}
        // 	]
        // },
        // {
        // 	id: 3,
        // 	label: "第三章　交通",
        // 	children: [
        // 		{
        // 			id: 31,
        // 			label: "31第一条　为了预防、控制艾滋病的传播和蔓延，救治艾滋病病毒感染者和艾滋病病人，保障人体健康和公共卫生，根据《中华人民共和国传染病防治法》、国务院《艾滋病防治条例》等有关法律、法规，结合本省实际，制定本条例。"
        // 		},
        // 		{
        // 			id: 32,
        // 			label: "32第二条　艾滋病防治工作坚持预防为主、防治结合的方针，建立政府领导、部门负责、社会参与的机制，采取宣传教育、行为干预和关怀救助等措施，实行综合防治。"
        // 		},
        // 		{
        // 			id: 33,
        // 			label: "33第三条  艾滋病防治工作坚持预防为主、防治结合的方针，实施政府组织领导、部门各负其责、全社会共同参与的工作机制，坚持综合治理、突出重点"
        // 		},
        // 		{
        // 			id: 34,
        // 			label: "34第四条  县级以上人民政府应当加强对艾滋病防治工作的领导，制定实施方案，明确部门职责，健全工作协调、考核、监督机制，推行领导负责制、工作责任制，将艾滋病防治工作纳入综合考核范围。"
        // 		}
        // 	]
        // }
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
      currentKey: "", //树形控件-当前选中的节点 m默认为0时展示标题和副标题
      checkedTreeObj: {}, //导航树选中的对象
      // reviewOpinionData:[],//审查意见列表数据
      //编辑审查意见
      isShowAddReviewOpinions: false,
      termsData: [], //对应条款数据
      curMode: "", //编辑审查意见当前的模式 添加 add 编辑 edit
      type: "修改", //默认修改
      defaultkey: [], //默认选中节点
      //左侧end=====

      //中间start===
      chooseData: [], //选中的值
      title: "", //标题
      centerTextType: "", //中间数据显示的样式 "chapter"章节 "items"条
      report_file: "", //生成报告文件路径
      allOpinionData: [], //全部数据-带综合意见
      //中间end===

      report_id: Number, //报告id
      downloadUrl: this.url.downloadUrl, //头像链接公共部分

      reviewStageStatus: "", //审查状态
      taskUuid: "", //任务的uuid
    };
  },
  created() {
    this.init(); //初始
  },
  mounted() {},
  methods: {
    //初始
    init() {
      this.uuid = window.localStorage.getItem("uuid");
      this.currentKey = this.uuid; //默认全篇 综合意见

      this.reviewStageStatus = window.localStorage.getItem("reviewStageStatus"); //审查状态 完成结束审查按钮是否显示 进行中:显示
      this.taskUuid = window.localStorage.getItem("taskUuid"); //任务的uuid

      //审查进度-从审查任务管理跳转过来需要先获取最新报告的id
      if (window.localStorage.getItem("reviewStage") == "report") {
        this.axios
          .get("/japi/check/get_latest_report_id_by_items/?item_uuid=" + this.uuid)
          .then((res) => {
            console.log("获取最新报告的id======");
            console.log(res);
            if (res.data.code == 200) {
              window.localStorage.setItem("report_id", res.data.data.id); //最新报告id
              this.report_id = parseInt(window.localStorage.getItem("report_id"));
              this.getReportDataFun(); //查看报告数据	- 左侧
            } else {
              window.localStorage.setItem("report_id", ""); //最新报告id 若全被删除了 则需要置为空
              this.$message({
                message: res.data.msg,
                type: "warning",
                duration: 3000,
              });
            }
          });
      } else {
        this.report_id = parseInt(window.localStorage.getItem("report_id"));
        this.getReportDataFun(); //查看报告数据	- 左侧
      }
      // this.createCatalogDataFun();//生成目录和全文
      this.getFileDataFun(); ///解析文件方法-源文右侧
      // this.reviewOpinionDataFun();//审查意见列表数据
    },

    //生成目录和全文
    createCatalogDataFun() {
      this.axios.put("/japi/analysis/handle/", { pk: this.uuid }).then((res) => {
        if (res.data.code == 200) {
          console.log("生成目录成功======");
          console.log(res);
          this.getFileDataFun(); //解析文件方法
        } else if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },
    //解析文件方法
    getFileDataFun() {
      this.axios.get("/japi/analysis/handle/?pk=" + this.uuid).then((res) => {
        if (res.data.code == 200) {
          console.log("解析文件成功======");
          console.log(res);
          this.titleSource = res.data.title;
          this.centerTextType = res.data.type;
          // this.treeData=res.data.data;
          this.rightData = res.data.data; //右侧数据
          // this.chooseData=this.treeData;//中间选中的数据
          //对应条款数据
          // let objTitle={id:this.uuid,label:"综合意见"};//综合意见传uuid
          // let objTitle={};//综合意见传uuid
          // this.termsData.push(objTitle);
          let obj = {};
          this.treeData.forEach((item) => {
            if (item.id.indexOf("_") > 0) {
              obj = { id: item.id, label: item.label };
            } else {
              obj = { id: item.id, label: "综合意见" };
            }
            this.termsData.push(obj);
            item.children.forEach((item) => {
              let obj = { id: item.id, label: item.label };
              this.termsData.push(obj);
            });
          });
          this.process = res.data.process; //审查进度
          this.reviewOpinionDataFun(this.process); //审查意见列表数据
        } else if (res.data.code == 500) {
          this.$message({
            message: res.data.msg,
            type: "warning",
            duration: 3000,
          });
        }
      });
    },

    //查看报告数据
    getReportDataFun() {
      this.axios
        .get("/japi/check/report_handle/?tag=detail&uuid=" + this.report_id)
        .then((res) => {
          if (res.data.code == 200) {
            console.log("查看报告成功======");
            console.log(res);
            this.title = res.data.data[0].title;

            this.allOpinionData = res.data.data[0].content; //带综合意见的数据
            this.chooseData = res.data.data[0].content; //中间选中的数据

            // this.treeData=res.data.data[0].content.slice(0);
            // 处理数据 将uuid中不带_的数据删除
            this.treeData = res.data.data[0].content.slice(0); //深拷贝 不改变原有数组
            this.treeData.forEach((item, index) => {
              if (item.id.indexOf("_") < 0) {
                this.treeData.splice(index, 1);
              }
            });
            // this.rightData=res.data.data;//右侧数据
            this.report_file = res.data.data[0].report_file; //生成报告 文件路径
            // //对应条款数据
            // let objTitle={id:this.uuid,label:"综合意见"};//综合意见传uuid
            // this.termsData.push(objTitle);
            // this.treeData.forEach(item=>{
            // 	let obj={id:item.id,label:item.label};
            // 	this.termsData.push(obj);
            // 	item.children.forEach(item=>{
            // 		let obj={id:item.id,label:item.label};
            // 		this.termsData.push(obj);
            // 	})
            // });
          } else if (res.data.code == 500) {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
    },

    //右侧start=====

    //右侧end=====

    //左侧start====
    //重置功能
    resetChecked() {
      this.checkedTreeObj = {};
      this.currentKey = this.uuid;
      //this.chooseData=this.treeData;
      this.chooseData = this.allOpinionData; //带综合意见的全部数据
      this.$refs.tree.setCheckedKeys([]);
      this.reviewOpinionDataFun(this.process); //审查意见列表数据
    },
    //树形控件实现单选功能
    handleNodeClick(data, checked, node, type) {
      if (checked === true) {
        // console.log(data);
        // console.log(checked);
        // console.log(node);
        this.checkedTreeObj = {};
        this.checkedTreeObj = data;
        if (type == "add") {
          //添加时只选中导航节点即可
          this.$refs.tree.setCheckedKeys([data.id]);
          this.reviewOpinionDataFun(this.process); //审查意见列表数据
        } else {
          this.currentKey = data.id;
          this.$refs.tree.setCheckedKeys([data.id]);
          this.getCenterChooseDataFun(); //筛选数据
          this.reviewOpinionDataFun(this.process); //审查意见列表数据
          this.$nextTick(() => {
            this.$refs[`title${data.id}`][0].scrollIntoView(true);
            this.rightScrollTop = this.$refs[`title${data.id}`][0].offsetTop;
            document.documentElement.scrollTop = 0;
          });
        }
      } else {
        if (this.currentKey == data.id) {
          this.$refs.tree.setCheckedKeys([data.id]);
        }
      }
    },
    //获取中间选中的数据
    getCenterChooseDataFun() {
      // 切换数据
      this.treeData.forEach((item) => {
        if (item.id == this.currentKey) {
          this.chooseData = [];
          this.chooseData.push(item);
        } else {
          if (!item.children) {
            return;
          }
          item.children.forEach((item) => {
            if (item.id == this.currentKey) {
              this.chooseData = [];
              let obj = { label: "", children: [] };
              obj.children.push(item);
              this.chooseData.push(obj);
            }
          });
        }
      });
    },
    //审查意见列表数据
    reviewOpinionDataFun() {
      this.axios
        .get(
          "/japi/check/check_advices_handle/?tag=all&uuid=" +
            this.currentKey +
            "&page=1&page_num=10000000&process=" +
            this.process
        )
        .then((res) => {
          if (res.data.code == 200) {
            console.log("审查意见列表数据成功======");
            console.log(res);
            this.reviewOpinionData = res.data.data.res;
          } else if (res.data.code == 500) {
            this.$message({
              message: res.data.msg,
              type: "warning",
              duration: 3000,
            });
          }
        });
    },
    //审查意见列表更多
    toReviewOpinionFun() {
      //跳转审查意见页面
      this.$router.push({ path: "/recordReview/reviewOpinion" });
      // this.$router.push("/refresh"); //保证审查意见标签选中
    },
    //查看意见
    editOpinionFun(id) {
      this.curMode = "edit";
      // this.currentKey="";//当前编辑意见的具体对应条款
      // this.type="";//建议类型
      this.isShowAddReviewOpinions = true;
      this.$nextTick(() => {
        this.$refs.viewReviewOpinions.getDataFun(id); //触发子组件获取数据的方法
      });
    },
    //查看意见完成后触发父组件的方法
    parentAddReviewOpinionsFun() {
      this.isShowAddReviewOpinions = false;
      this.$nextTick(() => {
        this.defaultkey.push(this.checkedTreeObj.id);
        this.handleNodeClick(this.checkedTreeObj, true, 0, "add"); //触发点击事件
      });
    },
    //将时间中的T换成空格
    handleTime(t) {
      t = t.replace(new RegExp(/(T)/g), "\u00a0");
      return t;
    },
    //左侧end====

    //中间start====
    //点击获取当前id值==右侧功能是一样的
    centerCurIdFun(item) {
      // console.log(item);
      this.defaultkey.push(item.id);
      this.currentKey = item.id;
      this.handleNodeClick(item, true); //触发点击事件
      // this.$refs.tree.setCurrentNode(item);
      // this.getCenterChooseDataFun();
    },

    //退回继续审查
    backReviewFun() {
      this.$confirm("请确认是否需要退回至备案审查环节，继续编辑审查意见？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false, //是否可通过点击遮罩关闭MessageBox
      })
        .then(() => {
          //确定
          this.$refs.returnReviewOpinion.childFun();
        })
        .catch(() => {
          //不加catch会报错
          this.$message({
            type: "info",
            message: "已取消退回继续审查",
          });
        });
    },
    //开启新一轮审查
    newRoundReviewFun() {
      this.$confirm("请确认是否需要重新开始新一轮备案审查工作？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false, //是否可通过点击遮罩关闭MessageBox
      })
        .then(() => {
          //确定
          this.$refs.uploadAgain.childFun();
        })
        .catch(() => {
          //不加catch会报错
          this.$message({
            type: "info",
            message: "已取消开启新一轮审查",
          });
        });
    },
    //完成结束审查
    completeReviewFun() {
      this.$confirm("请确认是否已完成所有审查工作并结束？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false, //是否可通过点击遮罩关闭MessageBox
      })
        .then(() => {
          //确定
          //	uuid为任务的uuid
          this.axios
            .put("/japi/check/check_task_handle/", {
              uuid: this.taskUuid,
              status: "done",
            })
            .then((res) => {
              if (res.data.code == 200) {
                console.log("完成结束审查成功======");
                console.log(res);
                this.$message({
                  message: "完成结束审查成功",
                  type: "success",
                  duration: 3000,
                });
                //修改审查状态
                window.localStorage.setItem("reviewStageStatus", "已完成");
                this.reviewStageStatus = "已完成";
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "warning",
                  duration: 3000,
                });
              }
            });
        })
        .catch(() => {
          //不加catch会报错
          this.$message({
            type: "info",
            message: "已取消完成结束审查",
          });
        });
    },
    //中间end====
  },
  computed: {
    //vue-seamless-scroll配置 文字滑动
    optionSwitch1() {
      return {
        autoPlay: false, //自动轮播
        switchSingleStep: 140, //轮播一次的宽度
        navigation: true, //左右滚动是否显示控制器按钮
        limitMoveNum: this.secondTitleData.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 2, //往左滚动
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/mixin.scss"; //定义方法
@import "../../../../assets/css/recordReviewDetail.scss"; //备案审查详情页样式
</style>
